import React, { useEffect, useState, useRef, useMemo } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "../../utils/api";
import QuillEditor from "../../components/QuillEditor/QuillEditor";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const formats = [
  "header",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "bullet",
  "align",
  "link",

  "code-block",
];

const EditThread = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [attachments, setAttachments] = useState([]);
  const quillRef = useRef(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  // Load thread data
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/threads/${id}`)
      .then((res) => {
        setTitle(res.data.title);
        setContent(res.data.content);
        setAttachments(res.data.attachments || []);
      })
      .catch((err) => console.error(err));
  }, [id]);

  const handleFileChange = (e) => {
    setAttachments([...attachments, ...e.target.files]);
  };

  const handleUpdate = async () => {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("content", content);
    attachments.forEach((file) => formData.append("attachments", file));

    try {
      await axios.put(`${API_BASE_URL}/threads/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      navigate(`/thread/${id}`);
      setSnackbarMessage("Thread updated successfully");
      setSnackbarOpen(true);
    } catch (err) {
      console.error(err);
      alert("Failed to update thread");
    }
  };

  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, 3, false] }],
        [{ size: ["12px", "14px", "16px", "18px", "24px", "32px", "48px"] }],

        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ align: [] }],
        ["link", "code-block"],
        ["clean"],
      ],
    }),
    []
  );

  return (
    <Box
      sx={{
        width: "auto",

        padding: "0px 20px",
        margin: "0px auto",
        padding: { xs: "20px", sm: "30px", md: "1px 80px" },
        border: "none",
        backgroundColor: "#ffffff",
        borderRadius: "8px",
      }}
    >
      {" "}
      <Button
        variant="outlined"
        startIcon={<ArrowBackIcon />}
        sx={{ marginTop: 1 }}
        onClick={() => navigate(`/Chat-Thread`)}
      >
        View All Threads
      </Button>
      <Typography variant="h5" gutterBottom>
        Edit Thread
      </Typography>
      <TextField
        fullWidth
        label="What can we do to help you?"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        sx={{ mb: 2 }}
      />
      <Box
        sx={{
          mb: 3,
          "& .ql-editor": { minHeight: 300, cursor: "text", lineHeight: 1.8 },
          "& .ql-editor.ql-blank::before": {
            fontStyle: "normal !important",
            fontSize: "16px !important",
            color: "#999",
          },
        }}
      >
        <QuillEditor
          ref={quillRef}
          value={content}
          onChange={setContent}
          modules={modules}
          formats={formats}
          placeholder="Provide details so members of the Hub or users of the website can provide answers
attachments upload materials or examples"
        />
      </Box>
      <input
        type="file"
        multiple
        onChange={handleFileChange}
        style={{ marginTop: 10 }}
      />
      <Button variant="contained" sx={{ mt: 2 }} onClick={handleUpdate}>
        Update Thread
      </Button>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity="success"
          onClose={() => setSnackbarOpen(false)}
          sx={{ width: "100%", backgroundColor: "green", color: "#fff" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default EditThread;
